import { render, staticRenderFns } from "./CncButton.vue?vue&type=template&id=243d70f0"
import script from "./CncButton.vue?vue&type=script&lang=js"
export * from "./CncButton.vue?vue&type=script&lang=js"
import style0 from "./CncButton.vue?vue&type=style&index=0&id=243d70f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports